module.exports = __webpack_public_path__ + "img/hotel-barra-mansa.a9dcf4bf.jpg";